export interface Comic {
  id: string;
  title: string;
  genre: string;
  cover: string;
  desc: string;
  author: string;
  status: "连载中" | "已完结";
  rating: number;
  views: number;
  chapters: number;
  updateTime: string;
  tags: string[];
  hot?: boolean;
  latest?: boolean;
  top?: boolean;
  featured?: string;
}

export const comics: Comic[] = [
  {
    id: "chunri-jidong",
    title: "春日悸动",
    genre: "campus",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20high%20school%20boy%20and%20girl%20meeting%20on%20a%20cherry%20blossom%20school%20path%2C%20spring%20petals%20falling%2C%20warm%20golden%20light%2C%20pastel%20pink%20and%20cream%20background%2C%20romantic%20youthful%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-chunri&orientation=portrait",
    desc: "转学第一天，我撞进了一团粉色的樱花里——也撞进了全校最受欢迎男生金贤宇的怀里。从那以后，我的高中生活彻底乱了套。一次次的偶然相遇、心跳加速的对视，这场关于青春与初恋的故事，在春天悄然拉开序幕。",
    author: "柚子酱",
    status: "连载中",
    rating: 9.4,
    views: 1280,
    chapters: 86,
    updateTime: "2小时前更新",
    tags: ["青春", "甜宠", "双向暗恋"],
    hot: true,
    latest: true,
    top: true,
    featured: "春日校园甜宠人气王",
  },
  {
    id: "zhuanxue-ttny",
    title: "转学那天遇见你",
    genre: "campus",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20transfer%20student%20girl%20with%20school%20bag%20standing%20in%20a%20classroom%20doorway%2C%20sunbeams%20through%20window%2C%20soft%20beige%20and%20warm%20tones%2C%20gentle%20smile%2C%20clean%20minimal%20background%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-zhuanxue&orientation=portrait",
    desc: "转学不是我的选择，可遇见你却是命中注定。背负着秘密来到新学校的我，在新同桌温柔的目光里一点点卸下防备。那些没说出口的话，那些藏在作业本里的纸条，都在说着同一件事——我想和你一起，把青春好好过完。",
    author: "一川",
    status: "连载中",
    rating: 9.1,
    views: 962,
    chapters: 54,
    updateTime: "昨天更新",
    tags: ["成长", "温柔", "校园"],
    hot: true,
  },
  {
    id: "fangxue-shn",
    title: "放学后的少年",
    genre: "campus",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20basketball%20boy%20after%20school%20on%20an%20empty%20court%20at%20dusk%2C%20orange%20sky%2C%20sporty%20youthful%20energy%2C%20clean%20minimal%20background%2C%20warm%20tones%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-fangxue&orientation=portrait",
    desc: "夕阳下的篮球场，只有他一个人还在练习。我作为唯一会留下来看他打球的人，逐渐被这个沉默少年的认真打动。当汗水与黄昏交织，一段关于陪伴、梦想与心动的故事就此展开。",
    author: "南风知意",
    status: "已完结",
    rating: 8.8,
    views: 745,
    chapters: 68,
    updateTime: "3天前更新",
    tags: ["运动", "青春", "治愈"],
    latest: true,
  },
  {
    id: "xindong-xkx",
    title: "心动选修课",
    genre: "campus",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20classroom%20scene%20with%20teacher%20and%20students%2C%20chalkboard%2C%20cozy%20warm%20light%2C%20school%20romance%20mood%2C%20clean%20minimal%20background%2C%20vibrant%20colors%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-xindong&orientation=portrait",
    desc: "为了凑学分误选了心理学选修课，却发现暗恋对象是课堂助教。每一次点名、每一次小组讨论都成了心跳的考验。原来学习恋爱这门课，比想象中更难拿分。",
    author: "白桃汽水",
    status: "连载中",
    rating: 9.0,
    views: 880,
    chapters: 42,
    updateTime: "5小时前更新",
    tags: ["校园", "轻松", "日常"],
    hot: true,
    top: true,
  },
  {
    id: "taitai-ggb",
    title: "天台上的告白",
    genre: "campus",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20boy%20confessing%20to%20a%20girl%20on%20a%20school%20rooftop%20under%20sunset%20sky%2C%20city%20skyline%2C%20romantic%20dramatic%20lighting%2C%20warm%20orange%20and%20pink%20tones%2C%20clean%20minimal%20composition%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-ttgb&orientation=portrait",
    desc: "全校都知道天台是告白圣地，却没人知道我已经偷偷喜欢了你三年。当毕业倒计时的牌子一天天翻过，我终于鼓起勇气，在天台说出了那句藏在心底很久的话。",
    author: "木子林",
    status: "已完结",
    rating: 9.2,
    views: 1102,
    chapters: 75,
    updateTime: "1周前更新",
    tags: ["青春", "告白", "纯爱"],
    latest: true,
  },
  {
    id: "moshi-tushuguan",
    title: "魔王的图书馆",
    genre: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20dark%20fantasy%20magical%20library%20with%20floating%20books%20and%20glowing%20runes%2C%20a%20hooded%20wizard%2C%20deep%20teal%20and%20purple%20glow%2C%20mysterious%20atmosphere%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-moshi&orientation=portrait",
    desc: "传说每位勇者都曾在魔王的图书馆里寻找制胜的魔法书，直到少年艾登在这里遇见自称'图书管理员'的神秘少女。她递给他一本写着《真相》的书，翻开的那一页，却是自己未来的结局。",
    author: "墨羽",
    status: "连载中",
    rating: 9.3,
    views: 1540,
    chapters: 92,
    updateTime: "3小时前更新",
    tags: ["冒险", "魔法", "反转"],
    hot: true,
    latest: true,
    top: true,
    featured: "年度奇幻神作大赏",
  },
  {
    id: "yueguang-qys",
    title: "月光契约师",
    genre: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20young%20contract%20mage%20under%20full%20moon%20with%20glowing%20magic%20circle%2C%20night%20fantasy%2C%20moonlight%20silver%20and%20blue%20tones%2C%20ethereal%20mysterious%20mood%2C%20clean%20background%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-ygqs&orientation=portrait",
    desc: "月光下的契约师能听见万物的低语，也能交换任何愿望的代价。见习契约师诗涵在一次任务中，被迫与冷峻的狼族守护者签订契约。随着契约的展开，两人之间的关系也从敌对走向并肩。",
    author: "拾月",
    status: "连载中",
    rating: 9.0,
    views: 990,
    chapters: 61,
    updateTime: "昨天更新",
    tags: ["契约", "神魔", "战斗"],
    hot: true,
  },
  {
    id: "longzu-zxs",
    title: "龙族转校生",
    genre: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20dragon-shifter%20schoolboy%20with%20small%20wings%20in%20a%20modern%20school%2C%20fantasy%20energy%2C%20teal%20and%20warm%20contrast%2C%20dynamic%20pose%2C%20clean%20minimal%20background%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-longzu&orientation=portrait",
    desc: "龙王之子为了历练化身人类混入学院，却在第一天就因没收住翅膀而引发骚动。隐藏身份的日子远比想象中麻烦，而那个总能识破他的同桌，似乎藏着更深的秘密。",
    author: "青禾",
    status: "连载中",
    rating: 8.9,
    views: 823,
    chapters: 48,
    updateTime: "2天前更新",
    tags: ["龙族", "学院", "搞笑"],
    latest: true,
  },
  {
    id: "yishijie-dh",
    title: "异世界的召唤",
    genre: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20summoned%20hero%20standing%20in%20a%20mystical%20portal%2C%20fantasy%20world%20scenery%2C%20sword%20and%20magic%20particles%2C%20vibrant%20fantasy%20colors%2C%20dramatic%20composition%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-yishijie&orientation=portrait",
    desc: "平凡的上班族林澈某天被神秘召唤阵卷入异世界，成了传说中拯救王国的勇者。没有金手指，没有预知未来，他只能靠社畜练就的谈判与复盘能力，在魔法世界闯出一条自己的路。",
    author: "陆离",
    status: "已完结",
    rating: 8.7,
    views: 687,
    chapters: 103,
    updateTime: "2周前更新",
    tags: ["异世界", "勇者", "智斗"],
  },
  {
    id: "xingyun-shushi",
    title: "星陨术士",
    genre: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20star-fall%20mage%20casting%20meteor%20magic%20at%20night%2C%20glowing%20stars%20and%20trails%2C%20deep%20navy%20and%20gold%2C%20epic%20fantasy%20mood%2C%20clean%20background%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-xysh&orientation=portrait",
    desc: "星陨之日，拥有双星血脉的少年被世人视为灾厄。为了洗清背负的罪名，他踏上收集星辰碎片的旅途。当命运的流星划过天际，真正的陨落与救赎才刚刚开始。",
    author: "千夜",
    status: "连载中",
    rating: 9.1,
    views: 856,
    chapters: 58,
    updateTime: "8小时前更新",
    tags: ["史诗", "命运", "热血"],
    top: true,
  },
  {
    id: "dushi-xiuxian",
    title: "都市修仙日记",
    genre: "urban",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20modern%20young%20cultivator%20in%20city%20night%20with%20glowing%20spirit%20energy%2C%20neon%20city%20lights%2C%20teal%20and%20gold%20accents%2C%20urban%20fantasy%20mood%2C%20clean%20composition%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-dsxx&orientation=portrait",
    desc: "一本祖传的修仙秘籍，让外卖小哥陈默意外踏入修真世界。白天送餐，晚上渡劫，在钢筋水泥的都市里与各方势力周旋。谁说修真只能在深山？这座城，就是我的道场。",
    author: "三更雨",
    status: "连载中",
    rating: 9.2,
    views: 1320,
    chapters: 88,
    updateTime: "1小时前更新",
    tags: ["修真", "都市", "轻松"],
    hot: true,
    latest: true,
    top: true,
    featured: "都市异能人气连载",
  },
  {
    id: "qiyue-lieren",
    title: "契约猎人",
    genre: "urban",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20stylish%20contract%20hunter%20with%20glowing%20contract%20scroll%20in%20modern%20city%2C%20mysterious%20yet%20cool%2C%20teal%20and%20amber%20tones%2C%20dynamic%2C%20clean%20background%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-qylr&orientation=portrait",
    desc: "在人类与异界生物共存的都市，契约猎人是维持秩序的最后一层防线。天才猎人韩朔接手了一个几乎不可能完成的委托，而委托人的真实身份，让整个城市的平衡岌岌可危。",
    author: "夜枭",
    status: "连载中",
    rating: 9.0,
    views: 1011,
    chapters: 70,
    updateTime: "昨天更新",
    tags: ["异能", "动作", "都市"],
    hot: true,
  },
  {
    id: "wuye-bld",
    title: "午夜便利店",
    genre: "urban",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20mysterious%20convenience%20store%20glowing%20at%20midnight%20street%2C%20warm%20window%20light%20vs%20cool%20night%2C%20urban%20slice-of-life%20fantasy%2C%20atmospheric%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-wybd&orientation=portrait",
    desc: "凌晨三点开门、天亮前打烊的便利店，只有失眠的人才会偶然撞见。在这里，每位客人付的不是钱，而是交换一个故事。值班店员小满，见证着都市人心里那些温暖又隐秘的角落。",
    author: "晚风",
    status: "连载中",
    rating: 9.3,
    views: 1176,
    chapters: 64,
    updateTime: "6小时前更新",
    tags: ["治愈", "单元剧", "都市"],
    latest: true,
    top: true,
    featured: "都市治愈单元剧场",
  },
  {
    id: "dushi-ctsws",
    title: "都市契约事务所",
    genre: "urban",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20modern%20office%20dealing%20with%20supernatural%20contracts%2C%20desk%20with%20glowing%20documents%2C%20city%20view%2C%20teal%20and%20warm%20tones%2C%20professional%20urban%20fantasy%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-dsct&orientation=portrait",
    desc: "市中心的写字楼里藏着一家专接'灵异委托'的事务所，老板是人狠话不多的前猎魔人。客户形形色色，案件光怪陆离，而每一次履约背后，都是对人性与规则的拷问。",
    author: "沈峙",
    status: "已完结",
    rating: 8.8,
    views: 608,
    chapters: 79,
    updateTime: "1月前更新",
    tags: ["灵异", "单元剧", "都市"],
  },
  {
    id: "xintiao-jiasu",
    title: "心跳加速",
    genre: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20two%20people%20in%20close%20romantic%20moment%2C%20heart%20sparkles%2C%20blush%2C%20soft%20pink%20and%20cream%20tones%2C%20cute%20youthful%20love%20mood%2C%20clean%20minimal%20background%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-xtjs&orientation=portrait",
    desc: "当闺蜜暗恋的对象开始频繁出现在我身边，每一次对视都让心跳失控。误会、试探、吃醋与告白，在这段拉扯中，我逐渐分不清自己究竟在为谁心跳加速。",
    author: "奶糖",
    status: "连载中",
    rating: 9.1,
    views: 1435,
    chapters: 95,
    updateTime: "4小时前更新",
    tags: ["甜宠", "三角", "心动"],
    hot: true,
    latest: true,
    top: true,
    featured: "恋爱榜持续霸榜",
  },
  {
    id: "qiyue-lianai",
    title: "契约恋爱",
    genre: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20romance%20couple%20with%20a%20playful%20contract%20document%2C%20cherries%20and%20pink%20accents%2C%20sweet%20modern%20love%20story%2C%20soft%20pastel%20background%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-qy-la&orientation=portrait",
    desc: "为了应付家里安排的相亲，我谎称已有恋人，还拉上不靠谱的同事顶替。谁知他竟当真拿了一份'契约恋爱协议'，上面写着期限三个月、不越界、不同居。只是三个月后，谁都没舍得先违约。",
    author: "蓝莓",
    status: "连载中",
    rating: 9.2,
    views: 1208,
    chapters: 82,
    updateTime: "7小时前更新",
    tags: ["契约", "搞笑", "甜宠"],
    hot: true,
  },
  {
    id: "xiaye-xg",
    title: "夏夜星光",
    genre: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20couple%20under%20summer%20night%20starry%20sky%20at%20seaside%2C%20fireworks%2C%20cool%20blue%20night%20with%20warm%20lamp%20glow%2C%20dreamy%20romantic%20mood%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-xyxg&orientation=portrait",
    desc: "海边小城的夏天，因一场流星雨而变得格外漫长。我在这座陌生的城市遇见他，两个人约定要在夏夜结束前一起看遍所有的星星。可当夏天过去，我们才明白，有些人注定要一起走下去。",
    author: "苏一",
    status: "已完结",
    rating: 9.4,
    views: 1672,
    chapters: 71,
    updateTime: "5天前更新",
    tags: ["纯爱", "治愈", "夏日"],
    latest: true,
    top: true,
    featured: "高分完结口碑作",
  },
  {
    id: "chulian-fcs",
    title: "初恋方程式",
    genre: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20math-obsessed%20school%20couple%20with%20floating%20numbers%20and%20formulas%2C%20charming%20nerdy%20romance%2C%20warm%20cream%20and%20pastel%2C%20cute%20clean%20background%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-clfs&orientation=portrait",
    desc: "人称'数学之神'的我，却解不开关于他的这道题。每一次相遇都像代入公式，可心动这道题从没有标准答案。当学霸遇上更低调的学霸，初恋的方程终于有了唯一的解。",
    author: "知白",
    status: "连载中",
    rating: 8.9,
    views: 736,
    chapters: 39,
    updateTime: "昨天更新",
    tags: ["校园", "学霸", "甜宠"],
    latest: true,
  },
  {
    id: "diqige-fj",
    title: "第七个房间",
    genre: "mystery",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20dark%20thriller%20room%20with%20seven%20doors%2C%20suspense%2C%20deep%20shadows%20and%20teal%20light%2C%20mysterious%20horror%20suspense%20mood%2C%20dramatic%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-dqg&orientation=portrait",
    desc: "一间密室，七扇门，只有一扇通向出口。被困于此的七个人各自隐瞒着秘密，而门外等待他们的，是精心设计的局。当真相一点点浮现，谁才是这场游戏真正的猎物？",
    author: "白鸦",
    status: "连载中",
    rating: 9.3,
    views: 1388,
    chapters: 66,
    updateTime: "3小时前更新",
    tags: ["烧脑", "密室", "反转"],
    hot: true,
    latest: true,
    top: true,
    featured: "悬疑热度断层第一",
  },
  {
    id: "wusheng-zc",
    title: "无声证词",
    genre: "mystery",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20detective%20examining%20silent%20clues%20at%20night%20with%20magnifying%20glass%2C%20film%20noir%20mood%2C%20moody%20teal%20and%20warm%20light%2C%20suspense%20atmosphere%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-wszc&orientation=portrait",
    desc: "资深刑警老周在退休前接下了最后一桩案子：一起没有目击者、没有证物、只有沉默的悬案。他循着蛛丝马迹回溯二十年前的旧案，却发现每一份'无声的证词'都在指向自己。",
    author: "陆政",
    status: "连载中",
    rating: 9.1,
    views: 920,
    chapters: 47,
    updateTime: "昨天更新",
    tags: ["刑侦", "推理", "本格"],
    hot: true,
  },
  {
    id: "shenye-dt",
    title: "深夜地铁站",
    genre: "mystery",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20an%20empty%20late-night%20subway%20station%20with%20a%20mysterious%20silhouette%2C%20fluorescent%20light%2C%20suspense%20urban%20thriller%2C%20cool%20teal%20tones%2C%20atmospheric%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-sydt&orientation=portrait",
    desc: "末班地铁驶过后，站台总会多出一个不属于任何时刻表的'加开车次'。误上这趟列车的乘客，只有解开谜题才能回到现实。而我，被困在这座永远不会停靠的午夜地铁站里，等待下一个乘客的证词。",
    author: "夜行",
    status: "已完结",
    rating: 8.9,
    views: 815,
    chapters: 52,
    updateTime: "3周前更新",
    tags: ["都市怪谈", "悬疑", "惊悚"],
    latest: true,
  },
  {
    id: "miwu-dangan",
    title: "迷雾档案",
    genre: "mystery",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20anime%20illustration%20of%20a%20secret%20agent%20opening%20a%20classified%20file%20box%20in%20foggy%20night%20city%2C%20mystery%20suspense%2C%20moody%20teal%20and%20grey%20tones%2C%20dramatic%2C%20high%20detail%20portrait&width=600&height=900&seq=cover-mwda&orientation=portrait",
    desc: "机密情报局的地下室里，堆满了无人认领的'迷雾档案'。特工夏岚奉命调查其中一份关于失踪人口卷宗的异常，却在追查过程中发现，这些档案竟在悄悄记录着每一个调查者。",
    author: "程也",
    status: "连载中",
    rating: 9.0,
    views: 703,
    chapters: 43,
    updateTime: "2天前更新",
    tags: ["特工", "阴谋", "悬疑"],
    top: true,
  },
];

export const heroBanners = [
  {
    id: "hero-campus",
    title: "校园青春专列发车",
    subtitle: "这个春天，让心跳停在课桌与天台之间",
    desc: "《春日悸动》《天台上的告白》等高分校园恋漫人气连载中，一键直达青春现场。",
    image: "https://readdy.ai/api/search-image?query=vibrant%20Korean%20manhwa%20style%20banner%20art%20of%20diverse%20high%20school%20students%20having%20fun%20in%20a%20sunny%20schoolyard%2C%20cherry%20blossoms%2C%20energetic%20youthful%20comic%20illustration%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20flat%20vector%20style%2C%20wide%20banner%20composition&width=1600&height=900&seq=hero-campus&orientation=landscape",
    link: "/category/campus",
    btn: "去校园分类看看",
  },
  {
    id: "hero-fantasy",
    title: "奇幻冒险新章开启",
    subtitle: "魔法、异世界与神魔征途，每周持续更新",
    desc: "《魔王的图书馆》《星陨术士》领衔，为你打开通往幻想世界的大门。",
    image: "https://readdy.ai/api/search-image?query=epic%20Korean%20manhwa%20style%20fantasy%20banner%20art%20with%20magic%2C%20dragons%20and%20heroes%2C%20glowing%20spells%2C%20vibrant%20teal%20gold%20and%20warm%20colors%2C%20dynamic%20action%20composition%2C%20wide%20banner%20illustration&width=1600&height=900&seq=hero-fantasy&orientation=landscape",
    link: "/category/fantasy",
    btn: "进入奇幻世界",
  },
  {
    id: "hero-mystery",
    title: "迷雾已至，真相待解",
    subtitle: "烧脑反转的悬疑推理，等你一起拨云见日",
    desc: "《第七个房间》《无声证词》悬疑榜霸榜中，越看越上头的沉浸式推理体验。",
    image: "https://readdy.ai/api/search-image?query=moody%20Korean%20manhwa%20style%20mystery%20banner%20art%20of%20a%20detective%20in%20a%20rainy%20urban%20night%2C%20silhouette%20and%20searchlights%2C%20teal%20and%20warm%20neon%20contrast%2C%20cinematic%20suspense%20atmosphere%2C%20wide%20banner%20illustration&width=1600&height=900&seq=hero-mystery&orientation=landscape",
    link: "/category/mystery",
    btn: "解开谜团",
  },
];

export function getComic(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByGenre(genreId: string): Comic[] {
  return comics.filter((c) => c.genre === genreId);
}